import React from 'react';
import { CheckIcon } from 'lucide-react';
import { foundingBenefits, foundingPerks, foundingPlans, foundingCommitments, foundingCommitmentsIntro, foundingRateNote } from '../../data/foundingOffer';
export function FoundingOffer() {
  return <div className="space-y-20 md:space-y-24" data-id="element-359" data-mp="3oi3l7jpsc9a4">
      {/* What founding members get */}
      <section aria-labelledby="founding-benefits-heading" data-id="element-360" data-mp="3jiqwsuj9mu5f">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-361" data-mp="kzk1x6p34drg">
          Your founding offer
        </p>
        <h2 id="founding-benefits-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-362" data-mp="g0z93sc5wwd1">
          What you have — permanently.
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-363" data-mp="6a4eo0oriqgi">
          {foundingBenefits.map(benefit => <div key={benefit.title} className="rounded-2xl border border-purple-200 border-t-2 border-t-purple-600 bg-white px-6 py-5" data-id="element-364" data-mp="13rv0iocphpjr">
              <h3 className="font-serif text-lg text-charcoal" data-id="element-365" data-mp="31788k4z7hr8u">
                {benefit.title}
              </h3>
              <p className="mt-2 text-sm text-charcoal/70 leading-relaxed" data-id="element-366" data-mp="367vxml3vjy0f">
                {benefit.description}
              </p>
            </div>)}
        </div>

        <div className="mt-6 rounded-2xl border-l-2 border-purple-600 bg-purple-50 px-6 py-6" data-id="element-367" data-mp="2weot12gykm1e">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-800 mb-4" data-id="element-368" data-mp="2iffh4ezsce38">
            What you keep — forever
          </p>
          <ul className="grid gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-369" data-mp="28i128jtifxd1">
            {foundingPerks.map(perk => <li key={perk} className="flex items-start gap-2.5 text-sm text-charcoal/80 leading-relaxed" data-id="element-370" data-mp="2dgvvygt0n6bx">
                <CheckIcon aria-hidden="true" className="mt-0.5 w-4 h-4 shrink-0 text-purple-700" data-id="element-371" data-mp="6rh4gwueygzn" />
                {perk}
              </li>)}
          </ul>
        </div>
      </section>

      {/* Plans */}
      <section aria-labelledby="founding-plans-heading" data-id="element-372" data-mp="58h4w4nauudf">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-373" data-mp="afqvy4qdl8t">
          Choose your plan
        </p>
        <h2 id="founding-plans-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-374" data-mp="3rhs647m1zom3">
          Your founding rate — locked in.
        </h2>
        <p className="mt-4 max-w-2xl text-base text-charcoal/70 leading-relaxed" data-id="element-375" data-mp="o11k4ja2t0yr">
          Two months free to start. Beginning Month 3, you're billed at your
          founding rate — locked in for life. For Bloom, Thrive, and Collective
          tiers, each practitioner on the plan must be individually verified
          before their profile is activated.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-376" data-mp="16z4cn81u1g1b">
          {foundingPlans.map(plan => <div key={plan.name} className={`relative flex flex-col rounded-2xl px-6 py-6 ${plan.highlighted ? 'border-2 border-purple-600 bg-purple-50' : 'border border-purple-200 bg-white'}`} data-id="element-377" data-mp="1f80f21zxe3ol">
              {plan.highlighted && <span className="absolute -top-3 left-6 rounded-full bg-purple-700 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white" data-id="element-378" data-mp="1t8up0p2mgcpd">
                  Most popular
                </span>}
              <h3 className="font-serif text-2xl text-charcoal" data-id="element-379" data-mp="225liqutpbfgs">{plan.name}</h3>
              <p className="mt-1 text-sm text-charcoal/60" data-id="element-380" data-mp="26zg8aevzmons">{plan.seats}</p>
              <p className="mt-4 font-serif text-3xl text-purple-800" data-id="element-381" data-mp="2bwg662iool3t">
                {plan.price}
                <span className="text-base text-purple-800/70" data-id="element-382" data-mp="2gy5gffy30uqu">
                  {plan.priceSuffix}
                </span>
              </p>
              <p className="mt-1 text-sm italic text-charcoal/50" data-id="element-383" data-mp="2ltkry18maek3">
                Locked for life
              </p>
              <ul className="mt-5 space-y-2.5" data-id="element-384" data-mp="3doipsf2z4mnq">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-2.5 text-sm text-charcoal/80 leading-relaxed" data-id="element-385" data-mp="3scvq1o93gro1">
                    <CheckIcon aria-hidden="true" className="mt-0.5 w-4 h-4 shrink-0 text-purple-700" data-id="element-386" data-mp="3ngeqzz0cwsw6" />
                    {feature}
                  </li>)}
              </ul>
              {plan.note && <p className="mt-5 pt-4 border-t border-purple-200 text-sm italic text-charcoal/60 mt-auto" data-id="element-387" data-mp="38n1r8q7ypcab">
                  {plan.note}
                </p>}
            </div>)}
        </div>
      </section>

      {/* Commitments */}
      <section aria-labelledby="founding-commitments-heading" data-id="element-388" data-mp="jwad5wdcdefn">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-389" data-mp="rguqpqj7gmwc">
          Your commitments
        </p>
        <h2 id="founding-commitments-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-390" data-mp="wgz6fecahdli">
          Help us build something exceptional.
        </h2>
        <p className="mt-4 max-w-2xl text-base text-charcoal/70 leading-relaxed" data-id="element-391" data-mp="mijhni0qigf6">
          {foundingCommitmentsIntro}
        </p>

        <ol className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-392" data-mp="1a9fe4sg4xzsr">
          {foundingCommitments.map((commitment, index) => <li key={commitment.text} className="flex items-start gap-3 text-base text-charcoal/80 leading-relaxed" data-id="element-393" data-mp="10hj4ck4osl8p" data-mpi={index}>
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-700 text-[11px] font-semibold text-white" data-id="element-394" data-mp="15f1gskhwxilg">
                {index + 1}
              </span>
              <span data-id="element-395" data-mp="27t5lqnz8mt7b">
                {commitment.text}
                {commitment.optional && <span className="ml-2 inline-block rounded-full border border-purple-300 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-purple-700 align-middle" data-id="element-396" data-mp="22tki4094hwo9">
                    Optional
                  </span>}
              </span>
            </li>)}
        </ol>

        <p className="mt-6 text-sm text-charcoal/55 leading-relaxed" data-id="element-397" data-mp="1out74mpk4r4c">
          *{foundingRateNote}
        </p>
      </section>
    </div>;
}